import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';

const initialState = {
  isDashboardDrawerOpened: true,
  isDesktopDrawerExpanded: true,
  isMobileDrawerOpen: false
};

const endpoints = {
  key: 'api/menu',
  master: 'master',
  dashboard: '/dashboard' // server URL
};

export function useGetMenuMaster() {
  const { data, isLoading } = useSWR(endpoints.key + endpoints.master, () => initialState, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  const memoizedValue = useMemo(
    () => ({
      menuMaster: data,
      menuMasterLoading: isLoading
    }),
    [data, isLoading]
  );

  return memoizedValue;
}

export function handlerDrawerOpen(isDashboardDrawerOpened) {
  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster) => {
      return {
        ...(currentMenuMaster || initialState),
        isDashboardDrawerOpened,
        isDesktopDrawerExpanded: isDashboardDrawerOpened
      };
    },
    false
  );
}

export function handlerDesktopDrawerOpen(isDesktopDrawerExpanded) {
  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster) => {
      return {
        ...(currentMenuMaster || initialState),
        isDashboardDrawerOpened: isDesktopDrawerExpanded,
        isDesktopDrawerExpanded
      };
    },
    false
  );
}

export function handlerMobileDrawerOpen(isMobileDrawerOpen) {
  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster) => {
      return {
        ...(currentMenuMaster || initialState),
        isMobileDrawerOpen
      };
    },
    false
  );
}
